export const ServerUrl = "https://orca-app-5dg8w.ondigitalocean.app/api/v1"
// export const ServerUrl = "http://localhost:5000/api/v1"
export const socketUrl = "https://orca-app-5dg8w.ondigitalocean.app"